import { useMemo } from "react";
import { usePropertyData } from "../../../components/property-admin-data-provider";
import { ConditionTypeEnum } from "../../witadmin/CRUD/Conditions/domain/ConditionType.enum";

export function useAllowedInventoryLines() {
  const propertyData = usePropertyData();

  return useMemo(() => {
    if (!propertyData?.inventories?.length) {
      return [];
    }
    return (
      propertyData.inventories
        // Insurance is disabled in Flight + Hotel mode, so `=== ENGINE` correctly excludes
        // FLIGHT_HOTEL conditions. See US-001 condition-type audit row 1.
        .filter(({ condition }) => condition.type === ConditionTypeEnum.ENGINE)
        .map(({ ticker, accommodation, condition, mealPlan, configuration }) => ({
          ticker,
          name: `${accommodation.name} / ${configuration.name}, ${mealPlan.name}, ${condition.name}`,
          filters: { accommodation, condition, configuration, mealPlan },
        }))
    );
  }, [propertyData]);
}
